<div class="modal-header">
    <h4 class="modal-title">Passwort Ändern</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="newForm">
        <div class="form-group">
            <label class="control-label" for="inputPasswort">Passwort</label>
            <input type="password" class="form-control" id="inputPasswort" name="Passwort" placeholder="Passwort"
                formControlName="Passwort">
        </div>
      </form>
  </div>
  <div class="modal-footer">
  <button type="submit" class="btn btn-success round" (click)="onSubmit()">Speichern</button>
  <button type="reset" class="btn round bg-red" style="color: white;" (click)="activeModal.close('Schließen')">Schließen</button>
  </div>
